/**
 * Vehicle Stock Status - Single source of truth
 * All labels, colors, and icons centralized for consistency and i18n support
 */
import { CheckCircle, Package, Clock, Tag, Car } from 'lucide-react';

// --- Status keys ---
export const STOCK_STATUS = {
  IN_PREPARATION: 'in_preparation',
  AVAILABLE: 'available',
  RESERVED: 'reserved',
  SOLD: 'sold',
};

// --- Full config per status (colors from VehicleDetail reference) ---
export const STOCK_STATUS_CONFIG = {
  [STOCK_STATUS.IN_PREPARATION]: {
    label: 'En pr\u00e9paration',
    labelShort: 'En pr\u00e9p.',
    labelPlural: 'En pr\u00e9paration',
    color: 'amber',
    icon: Clock,
    badge: 'bg-amber-500/20 text-amber-400',
    badgeActive: 'bg-amber-500/20 text-amber-400 ring-2 ring-amber-500',
  },
  [STOCK_STATUS.AVAILABLE]: {
    label: 'Disponible',
    labelShort: 'Dispo',
    labelPlural: 'Disponibles',
    color: 'green',
    icon: CheckCircle,
    badge: 'bg-green-500/20 text-green-400',
    badgeActive: 'bg-green-500/20 text-green-400 ring-2 ring-green-500',
  },
  [STOCK_STATUS.RESERVED]: {
    label: 'R\u00e9serv\u00e9',
    labelShort: 'R\u00e9serv\u00e9',
    labelPlural: 'R\u00e9serv\u00e9s',
    color: 'blue',
    icon: Package,
    badge: 'bg-blue-500/20 text-blue-400',
    badgeActive: 'bg-blue-500/20 text-blue-400 ring-2 ring-blue-500',
  },
  [STOCK_STATUS.SOLD]: {
    label: 'Vendu',
    labelShort: 'Vendu',
    labelPlural: 'Vendus',
    color: 'red',
    icon: Tag,
    badge: 'bg-red-500/20 text-red-400',
    badgeActive: 'bg-red-500/20 text-red-400 ring-2 ring-red-500',
  },
};

// --- Filter list (for Stock page tabs) ---
export const STOCK_FILTERS = [
  { key: STOCK_STATUS.AVAILABLE, label: STOCK_STATUS_CONFIG[STOCK_STATUS.AVAILABLE].labelPlural, icon: STOCK_STATUS_CONFIG[STOCK_STATUS.AVAILABLE].icon },
  { key: STOCK_STATUS.RESERVED, label: STOCK_STATUS_CONFIG[STOCK_STATUS.RESERVED].labelPlural, icon: STOCK_STATUS_CONFIG[STOCK_STATUS.RESERVED].icon },
  { key: STOCK_STATUS.IN_PREPARATION, label: STOCK_STATUS_CONFIG[STOCK_STATUS.IN_PREPARATION].labelPlural, icon: STOCK_STATUS_CONFIG[STOCK_STATUS.IN_PREPARATION].icon },
  { key: STOCK_STATUS.SOLD, label: STOCK_STATUS_CONFIG[STOCK_STATUS.SOLD].labelPlural, icon: STOCK_STATUS_CONFIG[STOCK_STATUS.SOLD].icon },
  { key: 'all', label: 'Tous', icon: Car },
];

// --- Dropdown options (for quick status change menus) ---
export const STOCK_STATUS_OPTIONS = Object.entries(STOCK_STATUS_CONFIG).map(([value, config]) => ({
  value,
  label: config.label,
  icon: config.icon,
}));

// --- Helper: get config for a status, with fallback ---
export const getStockStatusConfig = (status) =>
  STOCK_STATUS_CONFIG[status] || STOCK_STATUS_CONFIG[STOCK_STATUS.AVAILABLE];
